import { atom } from 'jotai';

import { jotaiStore } from '~/contexts/JotaiStoreContext/JotaiStoreContext';

export const networkStatusDebounceAtom = atom<number | null>(null);

export const getNetworkStatusDebounce = () =>
  jotaiStore.get(networkStatusDebounceAtom);

export const updateNetworkStatusDebounce = (debounceTime: number | null) =>
  jotaiStore.set(networkStatusDebounceAtom, debounceTime);
